import React, { useMemo } from 'react'
import { useTable } from 'react-table'
import { displayDateWithFormat, displayDate } from '../../utils/dateTime'
import Collapsible from '../Collapsible'
import { stringToSEO } from '../../utils/stringOps'

function ShowRelatedContent ({ relatedContents, relatedContentDataLength, hideTitle, showAOIs }) {

  const columns = useMemo(() => [
    {
      Header: 'Date',
      accessor: d => {
        return d.contentType === 9 ? <div title={d.introduction}>{displayDateWithFormat(d.publishedDate)}</div> : displayDate(d.publishedDate)
      },
      width: '100px'
    },
    {
      Header: 'Geography',
      accessor: 'geoNames',
      width: '110px'
    },
    {
      Header: 'Title',
      accessor: d => {
        return d.contentType === 9 ? d.title : <a
          href={`/#/content/${d.id}/${stringToSEO(d.title)}?referrer=portfolio_openrelatedcontent`} rel='noopener noreferrer' target='_self'> {d.title}
        </a>
      },
      width: ''
    },
    {
      Header: showAOIs ? 'Areas of Interest' : 'Content Type',
      accessor: showAOIs ? 'aoiNames' : 'contentTypeName',
      width: showAOIs ? '200px' : '130px'
    }
  ],
  []
  )

  const data = relatedContents || []

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns,
    data
  })

  return (
    <div className='article-relatedContent'>
      <Collapsible title={hideTitle ? '' : 'Timeline'} open>
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th width={column.width} {...column.getHeaderProps()}>{column.render('Header')}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row)
              return (
                <tr className='separated-solid' {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
        {(relatedContentDataLength > 0)
          ? (data.length > 0) ? null : (
            <div className='message alert alert-warning'>
              No results found for your selected filters.<br />
              Please adjust your selection.
            </div>)
          : <div className='message alert alert-info'>
              No content available to display in the Timeline.<br />
              Content has yet to be published for this Portfolio.
          </div>}
      </Collapsible>

    </div>
  )
}

export default ShowRelatedContent
